import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Camera, Instagram, Music, Copy, Download } from "lucide-react";

export default function EvidenceStatsPanel() {
  const [rows, setRows] = useState(null);
  const [titles, setTitles] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const [s, e] = await Promise.all([
          api.get("/admin/evidence-stats"),
          api.get("/admin/episodes"),
        ]);
        setRows(s.data.per_episode || []);
        const t = {};
        (e.data || []).forEach((ep) => { t[ep.number] = ep.title; });
        setTitles(t);
      } catch { setRows([]); }
    })();
  }, []);

  if (rows === null) return null;

  const grandTotal = rows.reduce((sum, r) => sum + (r.total || 0), 0);

  return (
    <div className="mb-10" data-testid="evidence-stats-panel">
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <Camera className="text-hotpink" size={22} />
        <h2 className="brush-title text-3xl md:text-4xl text-white">EVIDENCE <span className="text-hotpink">SHARES.</span></h2>
        <span className="scribble text-hotpink text-lg ml-auto">{grandTotal} total shares</span>
      </div>

      {rows.length === 0 ? (
        <p className="font-outfit text-white/40 text-sm italic bg-coal border border-white/10 p-5">no evidence downloads or shares yet — listeners share once they finish an episode.</p>
      ) : (
        <div className="bg-coal border border-white/10 p-5">
          <div className="grid grid-cols-[auto,1fr,auto,auto,auto,auto,auto] gap-x-4 gap-y-1 items-center text-[10px] uppercase tracking-widest font-outfit text-white/40 pb-2 border-b border-white/10">
            <span>Ep</span><span>Title</span>
            <span title="Instagram 4:5"><Instagram size={11} className="inline text-hotpink"/></span>
            <span title="TikTok 9:16"><Music size={11} className="inline text-hotpink"/></span>
            <span title="Copy link"><Copy size={11} className="inline text-hotpink"/></span>
            <span title="Original download"><Download size={11} className="inline text-hotpink"/></span>
            <span>Total</span>
          </div>
          <div className="divide-y divide-white/5 max-h-[520px] overflow-y-auto">
            {rows.map((r) => (
              <div key={r.episode_number} className="grid grid-cols-[auto,1fr,auto,auto,auto,auto,auto] gap-x-4 gap-y-1 items-center text-sm font-outfit py-2" data-testid={`ev-stat-${r.episode_number}`}>
                <span className="brush-title text-2xl text-white leading-none w-8">{String(r.episode_number).padStart(2, "0")}</span>
                <span className="text-white/80 truncate">{titles[r.episode_number] || `Ep ${r.episode_number}`}</span>
                <span className="text-white/70 text-center w-8">{r.instagram}</span>
                <span className="text-white/70 text-center w-8">{r.tiktok}</span>
                <span className="text-white/70 text-center w-8">{r.copy_link}</span>
                <span className="text-white/70 text-center w-8">{r.original}</span>
                <span className="text-hotpink font-bold text-center w-10">{r.total}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
